import { InteractionType } from '@azure/msal-browser';
import { useMsalAuthentication } from '@azure/msal-react';
import { PropsWithChildren } from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { AuthenticationRequired } from './authentication-required';
import { AuthorizedLayout } from 'shared/layouts/authorized-layout';

export function PrivateRoute({ children, ...rest }: PropsWithChildren<RouteProps>) {
  useMsalAuthentication(InteractionType.Redirect);
  return (
    <Route {...rest}>
      <AuthenticationRequired>
        <AuthorizedLayout>{children}</AuthorizedLayout>
      </AuthenticationRequired>
    </Route>
  );
}
